import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardGuard } from '../../shared-service/auth-guard.guard';

import { OverviewComponent } from './overview.component';
import { BaseService } from '../../shared-service/base.service';

const overviewRoutes: Routes = [
    {
        path: 'container',
        component: OverviewComponent,
        children:[
        	{
                path: 'details',
                canActivate: [AuthGuardGuard],
                //loadChildren: 'app/learner/my-learning/course-detail/course-detail.module#CourseDetailModule'
                loadChildren: ()=>import('../my-learning/course-detail/course-detail.module').then(m=>m.CourseDetailModule)
            },
            {
                path: 'assessment',
                canActivate: [AuthGuardGuard],
                //loadChildren: 'app/learner/my-learning/assessment/assessment.module#AssessmentModule'
                loadChildren: ()=>import('../my-learning/assessment/assessment.module').then(m=>m.AssessmentModule)
            },
            {
                path: 'checklist',
                canActivate: [AuthGuardGuard],
                //loadChildren: 'app/learner/my-learning/checklist/checklist.module#ChecklistModule'
                loadChildren: ()=>import('../my-learning/checklist/checklist.module').then(m=>m.ChecklistModule)
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(overviewRoutes)],
    exports: [RouterModule]
})
export class OverviewRoutingModule {
    constructor(private bs:BaseService) {
        this.bs.log('info',"Loaded OverviewRoutingModule");
    }
}
